module.exports = __webpack_public_path__ + "static/media/pain-overview@2x.5e7eaa84.png";